import * as React from 'react';
import { useNavigate } from 'react-router';
import { IconBadge } from '../../../components/synced/ui/IconBadge/IconBadge';
import styles from './ReportsList.module.css';

interface Report {
  name: string;
  link: string;
  desc: string;
  icon: string;
  tint: string;
  color: string;
  glow: string;
  bars: number[];
  formats: { icon: string; label: string; bg: string; color: string }[];
}

const REPORTS: Report[] = [
  {
    name: 'Справка',
    link: '/referenceReport',
    desc: 'Формирует справку по каждому проекту с таблицами: РД (расчёт долей), ПД (предъявление долга), КАП (капремонт) и ВГО (взаиморасчёты).',
    icon: 'fa-solid fa-circle-info',
    tint: '#eaf3ff',
    color: '#0a6ff0',
    glow: 'rgba(10,111,240,.35)',
    bars: [38, 55, 44, 68, 52, 82, 64],
    formats: [
      { icon: 'fa-solid fa-file-excel', label: 'XLSX', bg: '#e9f6ee', color: '#2b8a52' },
    ],
  },
  {
    name: 'Сводный отчёт по ПД и РД',
    link: '/projectConsolidated',
    desc: 'Сводные таблицы по всем проектам. РД — доли в натуральном и процентном выражении, SAL — баланс SAL по дебету и кредиту, SALdo — итоговое сальдо.',
    icon: 'fa-solid fa-layer-group',
    tint: '#e7f8ee',
    color: '#1c8a4d',
    glow: 'rgba(28,138,77,.32)',
    bars: [46, 60, 72, 54, 84, 66, 92],
    formats: [
      { icon: 'fa-solid fa-file-excel', label: 'XLSX', bg: '#e9f6ee', color: '#2b8a52' },
    ],
  },
];

const BAR_OPACITIES = [.28, .39, .50, .61, .72, .83, .94];

export const ReportsList: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <div className={styles.heading}>
        <h1 className={styles.title}>Отчёты</h1>
        <p className={styles.subtitle}>
          {REPORTS.length} доступных отчёта · формируются по данным ваших проектов
        </p>
      </div>

      <div className={styles.grid}>
        {/* Карточка отчета */}
        {REPORTS.map((r, ri) => (
          <article
            key={ri}
            className={styles.card}
            style={{ '--report-color': r.color, '--report-tint': r.tint } as React.CSSProperties}
          >
            {/* Хэдер карточки */}
            <div className={styles.cardHeader} style={{ background: r.tint }}>
              <span
                className={styles.cardIcon}
                style={{ background: r.color, boxShadow: `0 8px 18px ${r.glow}` }}
              >
                <i className={r.icon} />
              </span>

              <div className={styles.cardBars}>
                {r.bars.map((h, bi) => (
                  <span
                    key={bi}
                    className={styles.cardBar}
                    style={{
                      background: r.color,
                      opacity: BAR_OPACITIES[bi],
                      height: `${h}%`,
                    }}
                  />
                ))}
              </div>
            </div>

            {/* Тело карточки */}
            <div className={styles.cardBody}>
              <div className={styles.cardName}>{r.name}</div>
              <p className={styles.cardDesc}>{r.desc}</p>

              <div className={styles.formats}>
                {r.formats.map((f, fi) => (
                  <span
                    key={fi}
                    className={styles.formatBadge}
                    style={{ background: f.bg, color: f.color }}
                  >
                    <i className={f.icon} /> {f.label}
                  </span>
                ))}
              </div>
            </div>

            {/* Footer карточки */}
            <div className={styles.cardFooter}>
              <button
                className={styles.btnGenerate}
                onClick={() => navigate(r.link)}
              >
                  <i className="fa-solid fa-file-export" /> Сформировать
              </button>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};
